import { endpoints } from '@/config/api';
import { apiClient } from '@/lib/apiClient';
import type { CreateSavedPurposeDTO, SavedPurpose } from '@/types';

export const savedPurposeService = {
  async getSavedPurposes(): Promise<SavedPurpose[]> {
    return apiClient.get<SavedPurpose[]>(endpoints.savedPurposes.list);
  },

  async createSavedPurpose(data: CreateSavedPurposeDTO): Promise<SavedPurpose> {
    return apiClient.post<SavedPurpose>(endpoints.savedPurposes.create, data);
  },

  async deleteSavedPurpose(id: string): Promise<void> {
    return apiClient.delete(endpoints.savedPurposes.delete(id));
  },
};
